/**
 * @param {string} phone
 * @param {string} promo
 * @param {string} requestId
 */
export function createCartUrl(phone, promo, requestId) {
  return `https://www.dish.com/clearlink/packages/?tfn=${phone}&alt_rep_id=${promo}&site_location=${requestId}`
}
